import { CompanyType } from "@green0meter/api-client";

import { EntityTypesFields } from "@type/Entities";

export const entityTypesFields: EntityTypesFields = {
  [CompanyType.Subsidiary]: {
    name: "",
    vat: "",
    companyType: CompanyType.Subsidiary,
    features: [],
    currency: "",
    group: "",
    ownershipShare: 0,
    euTaxonomyAssesment: "",
  },
  [CompanyType.Asset]: {
    name: "",
    vat: "",
    companyType: CompanyType.Asset,
    features: [],
    currency: "",
    group: "",
    ownershipShare: 0,
    euTaxonomyAssesment: "",
  },
  [CompanyType.Supplier]: {
    name: "",
    vat: "",
    companyType: CompanyType.Supplier,
    features: [],
    naceSectionId: "",
    naceDivisionId: "",
    currency: "",
    group: "",
    annualTurnover: 0,
    isExternal: false,
  },
  [CompanyType.Client]: {
    name: "",
    vat: "",
    companyType: CompanyType.Client,
    features: [],
    currency: "",
    group: "",
  },
  [CompanyType.Product]: {
    name: "",
    vat: "",
    companyType: CompanyType.Product,
    features: [],
    currency: "",
    group: "",
  },
  [CompanyType.Fund]: {
    name: "",
    vat: "",
    companyType: CompanyType.Fund,
    features: [],
    currency: "",
    group: "",
  },
};
